/** Pattern that matches a string with format: `###.####.####.##` where `#` is any digit */
export const AVS_PATTERN = '[0-9]{3}\\.[0-9]{4}\\.[0-9]{4}\\.[0-9]{2}' as const;

/** Pattern that matches a string with format DD.MM.YYYY or DD.MM.YY */
export const DATE_PATTERN =
  '^(0?[1-9]|[12][0-9]|3[01])\\.(0?[1-9]|1[0-2])\\.([0-9]{2}|[0-9]{4})$' as const;

/** Pattern that matches entire strings that contain only non-digit characters */
export const NON_DIGITS_PATTERN = '^([^0-9]*)$' as const;

/** Pattern that matches entire strings that contain only digit characters */
export const DIGITS_ONLY_PATTERN = '^[0-9]*$' as const;
